import { Injectable } from '@angular/core';
import { Customer } from '../../../libs/proto/commUnity_pb';
import { BinaryWriter } from 'google-protobuf';
import { GroupCustomers } from '../../../libs/proto/mobile_pb';

@Injectable({
  providedIn: 'root'
})
export class CustomerConversionService {

  constructor() { }

  FromStorage(data: any, callback: (cus: Customer, errorConvert: any) => void) {
    try {
      callback( Customer.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorage(req: Customer) {
    const w = new BinaryWriter();
    Customer.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }
}
